import { createContext, useContext } from "react";

import type { subscriptionGet } from "../../services/api.service.js";

export type SubscriptionContextType = Omit<
  Awaited<ReturnType<typeof subscriptionGet>>,
  "meta"
> & {
  __ctx_init: boolean;
  trialExpiresAt: Date | null;
};

export const SubscriptionContext = createContext<SubscriptionContextType>({
  __ctx_init: false,
  features: [],
  planId: null,
  source: "none",
  status: "inactive",
  trialExpiresAt: null,
});

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);

  if (!context.__ctx_init) {
    throw new Error(
      "useSubscription must be used within a SubscriptionProvider"
    );
  }

  return context;
};
